import React from "react";
import SidebarTenagaKesehatan from "../../components/SidebarTenagaKesehatan";
import TopBarChatPasienTK from "../../components/TopBarChatPasienTK";
import ChatPasienTK from "../../components/ChatPasienTK";
import "../../CSS/LaporKendalaTenagaKesehatan.css"; 

function HalamanLaporkanKendalaNakes() {
  return (
    <div className="laporkan-page">
      {/* Sidebar kiri */}
      <SidebarTenagaKesehatan />

      {/* Area kanan */}
      <div className="content">
        <TopBarChatPasienTK />

        {/* Konten utama */}
        <div className="main-content">
          <ChatPasienTK />
        </div>

        
      </div>
    </div>
  );
}

export default HalamanLaporkanKendalaNakes;
